var map = {
	"./PPSDM - 1.jpg": 30493,
	"./PPSDM - 2.jpg": 14463,
	"./PPSDM - 3.jpg": 54821,
	"./PPSDM - 4.jpg": 44867,
	"./PPSDM - 5.jpg": 36451,
	"./PPSDM - 6.jpg": 93496,
	"./document thumbnail/thumb-1.png": 42992,
	"./document thumbnail/thumb-2.png": 42976,
	"./document/contoh nomor 1.pdf": 24289,
	"./document/sample2.pdf": 62786,
	"./document/sample3 long long name document.pdf": 30613,
	"./video thumbnail/dummy.txt": 44698,
	"./video/dummy.txt": 93780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67102;